import React from 'react';
import '../../scss/components/_blog-card.scss'


const BlogCard = props => (
    <div className = "contentBlock d-flex justify-content-between flex-wrap gridContainer">
        <div className="verticalBlogColumn mb-0 innerBlogContainer" style={cardStyle(props.cardColor)}>
            <a href={props.link} target="_blank">
                <div class="blog-image-container">
                    <div className="icon">
                        <img src={'/resources/external-link-icon.svg'} alt="Icon external link" />
                    </div>
                    <div class="blog-image" style={imgUrl(props.urlImg)}></div>
                </div>
            </a>
            <div className ="blog-header">
                <p class="blog-subtitle">{props.subtitle}</p>
                <h2 class="blog-title">{props.title}</h2>
            </div>
            <div className="blog-body">
                <p class="blog-description">{props.description}</p>
            </div>
            <div className ="blog-footer">
                <p>{props.footer} <a href={props.link}  target="_blank" className="ctaStandard"> {props.cta} </a></p>
            </div>                          
        </div>
    </div> 
);

const imgUrl = (urlImg) => ({
    backgroundImage : `url(${urlImg})`

})

const cardStyle = (cardColor)=>({
    backgroundColor: cardColor

})
export default BlogCard;
    
    